import { lazy, Suspense } from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  SxProps,
  Theme,
} from '@mui/material';

import { useLanguage } from '../../hooks';
import { DSSpinner } from '../uiComponents/logoSpinner';

const QrCodeStylingComponent = lazy(() => import('./styledQR'));

const customStyles: Record<string, SxProps<Theme>> = {
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    fontWeight: '600px',
  },
  confirmBtn: {
    textTransform: 'capitalize',
  },
  modalActions: {
    display: 'flex',
    justifyContent: 'center',
  },
};

interface OnboardingProps {
  open: boolean;
  onClose: () => void;
  linkToken: string;
  formId: string;
}

export const Onboarding = ({ open, onClose, linkToken, formId }: OnboardingProps) => {
  const lang = useLanguage();

  return (
    <Dialog
      open={open}
      onClose={() => onClose()}
      maxWidth={'xs'}
    >
      <DialogContent sx={customStyles.modalContent}>
        <DialogContentText
          variant='h2'
          sx={customStyles.title}
        >
          {lang.form_builder.testYourForm3}
        </DialogContentText>
        <Suspense fallback={<DSSpinner />}>
          <QrCodeStylingComponent
            data={
              'https://app.datascope.io/?link=https%3A%2F%2Fmydatascope.com%2Fresume%3Flogin_token%3D' +
              linkToken +
              '%26form_id%3D' +
              formId +
              '&login_token=' +
              linkToken +
              '&apn=com.datascope&isi=1132697668&ibi=org.datascope.form&utm_source=email_invitation&utm_medium=profile_setup'
            }
          ></QrCodeStylingComponent>
        </Suspense>
        <DialogContentText align='center'>{lang.form_builder.testYourForm5}</DialogContentText>
      </DialogContent>
      <DialogActions sx={customStyles.modalActions}>
        <Button
          onClick={onClose}
          color='primary'
          variant='contained'
          sx={customStyles.confirmBtn}
        >
          {lang.form_builder.ok}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
